export default function joinWords(words: string[], sep = ', ', lastTwoSep = ' and ') {
  if (words.length <= 2) {
    return words.join(lastTwoSep);
  } else {
    let lastTwo = words.splice(words.length - 2, words.length);
    words.push(lastTwo.join(`,${lastTwoSep}`));

    return words.join(sep);
  }
}

export function joinWordsAsSnippets(words: string[], sep?: string, lastTwoSep?: string) {
  let snippets = words.map((word) => `<code>${word}</code>`);

  return joinWords(snippets, sep, lastTwoSep);
}
